module.exports = "<highcharts-chart\n  [Highcharts]=\"Highcharts\"\n  [options]=\"chartOptions\"\n  [callbackFunction]=\"loadChart\"\n  [(update)]=\"updateFlag\"\n  style=\"width: 100%; height: 100%;display: block;\"\n></highcharts-chart>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/borneo/prod/borneo_app/src/app/shared/components/charts/chart/chart.component.html
// module id = ../../../../../src/app/shared/components/charts/chart/chart.component.html
// module chunks = main